var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamsGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 3H14.5V21H6.25C5.38805 21 4.5614 20.6576 3.9519 20.0481C3.34241 19.4386 3 18.612 3 17.75V6.25C3 5.38805 3.34241 4.5614 3.9519 3.9519C4.5614 3.34241 5.38805 3 6.25 3ZM17.75 21H16V16H21V17.75C21 18.612 20.6576 19.4386 20.0481 20.0481C19.4386 20.6576 18.612 21 17.75 21ZM21 14.5H16V9.5H21V14.5ZM16 8V3H17.75C18.612 3 19.4386 3.34241 20.0481 3.9519C20.6576 4.5614 21 5.38805 21 6.25V8H16ZM6 13.75C6 14.164 6.336 14.5 6.75 14.5H11.25C11.4489 14.5 11.6397 14.421 11.7803 14.2803C11.921 14.1397 12 13.9489 12 13.75C12 13.5511 11.921 13.3603 11.7803 13.2197C11.6397 13.079 11.4489 13 11.25 13H6.75C6.55109 13 6.36032 13.079 6.21967 13.2197C6.07902 13.3603 6 13.5511 6 13.75ZM7.25 6.5C6.56 6.5 6 7.06 6 7.75V10.25C6 10.94 6.56 11.5 7.25 11.5H10.75C11.44 11.5 12 10.94 12 10.25V7.75C12 7.06 11.44 6.5 10.75 6.5H7.25ZM7.5 10V8H10.5V10H7.5ZM6 16.75C6 17.164 6.336 17.5 6.75 17.5H11.25C11.4489 17.5 11.6397 17.421 11.7803 17.2803C11.921 17.1397 12 16.9489 12 16.75C12 16.5511 11.921 16.3603 11.7803 16.2197C11.6397 16.079 11.4489 16 11.25 16H6.75C6.55109 16 6.36032 16.079 6.21967 16.2197C6.07902 16.3603 6 16.5511 6 16.75Z",
    fill: "#51CDA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamsGreen);
export default __webpack_public_path__ + "static/media/streamsGreen.9314957b31ab02f3bdbf7548588cb9bc.svg";
export { ForwardRef as ReactComponent };